// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { CommitmentPandaDocFragmentDoc, BidContractPandaDocFragmentDoc } from './PandaDocModalContent.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DeleteUploadedPandaDocMutationVariables = Types.Exact<{
  input: Types.DeletePandaDocInput;
}>;


export type DeleteUploadedPandaDocMutation = { __typename?: 'Mutation', deletePandaDoc: { __typename?: 'DeletePandaDocResult', owner:
      | { __typename?: 'BidContractRevision', id: string, bidRevisionStatus: { __typename?: 'BidContractRevisionStatusDetail', code: Types.BidContractRevisionStatus, name: string }, canCreatePandaDoc: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, pandaDoc?: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined } | null | undefined }
      | { __typename?: 'ChangeEvent' }
      | { __typename?: 'Commitment', id: string, status: Types.CommitmentStatus, canCreatePandaDoc: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, pandaDoc?: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined } | null | undefined }
      | { __typename?: 'CommitmentChangeOrder' }
      | { __typename?: 'DevelopmentCommitment' }
      | { __typename?: 'Invoice' }
      | { __typename?: 'LienWaiver' }
     } };


export const DeleteUploadedPandaDocDocument = gql`
    mutation DeleteUploadedPandaDoc($input: DeletePandaDocInput!) {
  deletePandaDoc(input: $input) {
    owner {
      ...BidContractPandaDoc
      ...CommitmentPandaDoc
    }
  }
}
    ${BidContractPandaDocFragmentDoc}
${CommitmentPandaDocFragmentDoc}`;

/**
 * __useDeleteUploadedPandaDocMutation__
 *
 * To run a mutation, you first call `useDeleteUploadedPandaDocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUploadedPandaDocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUploadedPandaDocMutation, { data, loading, error }] = useDeleteUploadedPandaDocMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUploadedPandaDocMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUploadedPandaDocMutation, DeleteUploadedPandaDocMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUploadedPandaDocMutation, DeleteUploadedPandaDocMutationVariables>(DeleteUploadedPandaDocDocument, options);
      }
export type DeleteUploadedPandaDocMutationHookResult = ReturnType<typeof useDeleteUploadedPandaDocMutation>;
export type DeleteUploadedPandaDocMutationResult = ApolloReactCommon.MutationResult<DeleteUploadedPandaDocMutation>;